export default __webpack_public_path__ + "static/media/CustoImage (7).0be57711.png";